import { ImportDialog, type ImportField } from '@/components/import/ImportDialog';
import { buildTemplate, TEMPLATE_DETTES_FOURNISSEURS } from '@/lib/import-templates';
import {
  useImportDettesFournisseurs,
  type ImportDetteRow,
} from '@/hooks/queries/useDettesFournisseurs';

interface Props {
  open: boolean;
  onOpenChange: (o: boolean) => void;
  entrepriseId: string;
  activiteId: string | null;
}

const FIELDS: ImportField[] = [
  { key: 'fournisseur', label: 'Fournisseur', required: true },
  { key: 'telephone', label: 'Téléphone' },
  { key: 'rib', label: 'N° compte (RIB)' },
  { key: 'email', label: 'Email' },
  { key: 'annee', label: 'Année', required: true },
  { key: 'formation', label: 'Formation' },
  { key: 'date_formation', label: 'Date formation' },
  { key: 'reference_facture', label: 'N° facture', required: true },
  { key: 'montant_dette', label: 'Montant dette (DA)', required: true },
  { key: 'montant_regle', label: 'Montant réglé (DA)' },
  { key: 'statut', label: 'Statut' },
  { key: 'mode_paiement', label: 'Mode paiement' },
  { key: 'reference_operation', label: 'Réf opération' },
  { key: 'date_virement', label: 'Date virement' },
  { key: 'observation', label: 'Observation' },
];

export function ImportDettesFournisseursDialog({
  open,
  onOpenChange,
  entrepriseId,
  activiteId,
}: Props): JSX.Element {
  const importMut = useImportDettesFournisseurs();

  return (
    <ImportDialog<ImportDetteRow>
      open={open}
      onOpenChange={onOpenChange}
      title="Importer les dettes fournisseurs (XLSX)"
      fields={FIELDS}
      generateTemplate={() => buildTemplate(TEMPLATE_DETTES_FOURNISSEURS)}
      templateFilename={TEMPLATE_DETTES_FOURNISSEURS.filename}
      requiredHeaders={TEMPLATE_DETTES_FOURNISSEURS.requiredHeaders}
      onImport={async (rows) => {
        if (!entrepriseId) {
          return { success: 0, errors: ['Entreprise non sélectionnée'] };
        }
        const result = await importMut.mutateAsync({
          entrepriseId,
          activiteId,
          rows,
        });
        const summary: string[] = [];
        if (result.fournisseursCrees > 0)
          summary.push(`${result.fournisseursCrees} fournisseur(s) créé(s)`);
        if (result.formationsCreees > 0)
          summary.push(`${result.formationsCreees} formation(s) créée(s)`);
        if (summary.length > 0) result.errors.unshift(`ℹ ${summary.join(' · ')}`);
        return { success: result.dettesCrees, errors: result.errors };
      }}
    />
  );
}
